/** Resolves the backend origin for API calls. Production builds require REACT_APP_API_URL. */
const trimTrailingSlash = (url) => String(url || "").replace(/\/$/, "");

const NESTFIN_CHECKOUT_HOSTS = new Set(["nestfin.app", "www.nestfin.app"]);

export const getApiBaseUrl = () => {
  // WhatsApp Pay Now links open on nestfin.app; use same-origin /api (proxied to backend).
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (NESTFIN_CHECKOUT_HOSTS.has(host)) {
      return trimTrailingSlash(window.location.origin);
    }
  }

  const fromEnv = trimTrailingSlash(process.env.REACT_APP_API_URL);
  if (fromEnv) return fromEnv;

  if (process.env.NODE_ENV === "production") {
    console.error(
      "REACT_APP_API_URL is not set. Configure it before building for production.",
    );
    return "";
  }

  return "http://localhost:9090";
};

export const Base_URL = getApiBaseUrl();
